import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=700c4b2c"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports